<script>
export default {
  name: 'LinkHistoricoAlteracoes',
  props: {
    to: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => 'Label'
    },
    icon: {
      type: String,
      required: false,
      default: () => ''
    }
  }
}
</script>

<template>
  <router-link :to="to" target="_blank">
    <span class="btn btn-dark btn-sm text-xs">
      <i :class="`fa ${icon}`"></i> {{label}}
    </span>
  </router-link>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// LinkHistoricoAlteracoes.vue?f0b936a2